import { z } from 'zod'
import { ROLES } from '../roles.ts'
import { nonEmpty, uuid } from './common.ts'

// Stored lowercased: the Google identity that signs in is matched against
// this, and email comparison must not depend on how someone typed it.
export const email = z.string().trim().toLowerCase().email().max(254)

export const createStaff = z.object({
  id: uuid,
  email,
  fullName: nonEmpty(120),
  role: z.enum(ROLES),
})
export type CreateStaff = z.infer<typeof createStaff>

export const updateStaff = z.object({
  fullName: nonEmpty(120).optional(),
  role: z.enum(ROLES).optional(),
  isActive: z.boolean().optional(),
  // Optimistic locking. The client sends the version it loaded; a mismatch
  // means someone else edited in between and the write is rejected rather
  // than silently overwriting their change.
  version: z.number().int().positive(),
})
export type UpdateStaff = z.infer<typeof updateStaff>
